<div class="card bg-card-new card-radius-06 border-0">
    <div class="p-4">
        <div class="flex flex-col">
            <div class="flex flex-wrap justify-between">
                <div class="flex flex-col">
                    <h4 class="my-2">{{"property_history"|translate}}</h4>
                    <small class="mb-3 text-xs">{{"view_past_properties"|translate}}</small>
                </div>

                <div class="search-field">
                    <form class="nosubmit">
                        <input class="nosubmit" type="search" matInput (keyup)="applyFilter($event)" placeholder="Property ID" #input>
                    </form>
                </div>
            </div>



              <div class="card-table overflow-auto" *ngIf="dataSource">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0 w-full">

                  <ng-container matColumnDef="id">
                    <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                    <td mat-cell class="id-td" *matCellDef="let row"> {{row.contractID}} </td>
                  </ng-container>


                  <ng-container matColumnDef="property">
                    <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"property"|translate}} </th>
                    <td class="table-td" mat-cell *matCellDef="let row"> {{translateHelper.localize(row.property?.name)}} </td>
                  </ng-container>
                  <ng-container matColumnDef="contractType">
                    <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"contract_type"|translate}} </th>
                    <td class="table-td" mat-cell *matCellDef="let row"> {{getContractType(row.contractType)}} </td>
                  </ng-container>

                  <ng-container matColumnDef="startDate">
                    <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"date_start"|translate}} </th>
                    <td class="table-td" mat-cell *matCellDef="let row" > {{row.startDate|date}} </td>
                  </ng-container>
                  <ng-container matColumnDef="endDate">
                    <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"date_end"|translate}} </th>
                    <td class="table-td" mat-cell *matCellDef="let row" > {{row.endDate|date}} </td>
                  </ng-container>

                  <ng-container matColumnDef="lastInvoiceDate">
                    <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"last_invoice_date"|translate}} </th>
                    <td class="table-td" mat-cell *matCellDef="let row" > {{row.lastInvoiceDate|date}} </td>
                  </ng-container>

                  <ng-container matColumnDef="lastInvoicePrice">
                    <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"last_invoicePrice"|translate}} </th>
                    <td class="table-td" mat-cell *matCellDef="let row" >
                     <span *ngIf="row.status !== 'new'">{{row.lastInvoicePrice|currencyFormat}}</span>
                     <span *ngIf="row.status === 'new'"> - </span></td>
                  </ng-container>
                  <ng-container matColumnDef="balance">
                    <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"balance"|translate}} </th>
                    <td class="table-td" mat-cell *matCellDef="let row" >
                     <span *ngIf="row.status !== 'new'">{{row.balance|currencyFormat}}</span>
                     <span *ngIf="row.status === 'new'"> - </span></td>
                  </ng-container>

                  <tr  mat-header-row  *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row;  columns: displayedColumns;" [routerLink]="(pageType=='property')?['/account/property',row._id]:['/account/ownerProperty',row._id]" class="cursor-pointer"></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                  </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
              </div>
        </div>




    </div>

</div>
